import React from 'react';
import { Reveal } from './Reveal';
import { keyNumbers } from '../data/content';
export function KeyNumbers() {
  return <section aria-label="Key numbers" className="w-full bg-white px-5 py-16 sm:px-8" data-id="element-109" data-mp="e9ogrrqvlcl6">
      <div className="mx-auto w-full max-w-5xl" data-id="element-110" data-mp="3vqfqruy0rd6k">
        <Reveal data-id="element-111" data-mp="3vnjs24eckkh2">
          <dl className="grid grid-cols-2 gap-4 md:grid-cols-4" data-id="element-112" data-mp="4itsyixze4xm">
            {keyNumbers.map(stat => <div key={stat.label} className="flex flex-col-reverse items-center rounded-card bg-tint px-4 py-8 text-center shadow-card" data-id="element-113" data-mp="s8xmfxhggoaw">
                <dt className="mt-1 text-xs font-semibold uppercase tracking-wider text-navy/65" data-id="element-114" data-mp="j7zpfz5fph1t">
                  {stat.label}
                </dt>
                <dd className="font-display text-4xl font-extrabold tracking-tight text-navy sm:text-5xl" data-id="element-115" data-mp="n89xrigp8jju">
                  {stat.value}
                </dd>
              </div>)}
          </dl>
        </Reveal>
      </div>
    </section>;
}